export function toInteger(val: string): number {
  return parseInt(val, 10)
}

export function isNumberFormat(val: string): boolean {
  return !Number.isNaN(Number(val))
}
